var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 -1 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00676 1.84889C8.00676 1.84889 8.96203 0.861739 10.1 0.355808C11.3851 -0.215547 13.0181 -0.0623941 14 0.555828C16.0194 1.82732 16.6454 4.70583 15.3 7.35583C14.1099 9.6764 12.5922 11.1683 11.1 12.3594C10.1546 13.114 8.01352 14.3558 8.01352 14.3558C8.01352 14.3558 5.84905 13.1061 4.91354 12.3594C3.42132 11.1683 1.90361 9.6764 0.713537 7.35583C-0.631876 4.70583 -0.0058918 1.82732 2.01353 0.555828C2.99541 -0.0623941 4.62843 -0.215547 5.91354 0.355808C7.05149 0.861737 8.00676 1.84889 8.00676 1.84889ZM8.01194 12.8447C8.16516 12.7521 8.33687 12.6474 8.51766 12.5355C9.17385 12.129 9.88418 11.6665 10.289 11.3434C11.6913 10.2241 13.063 8.86799 14.142 6.76502C15.2624 4.55583 14.6188 2.48164 13.3073 1.65593C12.7056 1.27704 11.5317 1.14198 10.6281 1.5437C10.2064 1.7312 9.78404 2.02633 9.44708 2.30048C8.9437 2.71003 7.99997 3.60583 7.99997 3.60583C7.99997 3.60583 7.06723 2.70792 6.56645 2.30048C6.22948 2.02633 5.80714 1.7312 5.38541 1.5437C4.48186 1.14198 3.30796 1.27704 2.70619 1.65593C1.39478 2.48163 0.751113 4.55578 1.87149 6.76494C2.95049 8.86796 4.3222 10.2241 5.72452 11.3434C6.12294 11.6614 6.83495 12.1231 7.49665 12.5311C7.68092 12.6447 7.85598 12.751 8.01194 12.8447Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeAction);
export default __webpack_public_path__ + "static/media/likeAction.716977bc0488321c2eb63e82349ccdbe.svg";
export { ForwardRef as ReactComponent };